module.exports = __webpack_public_path__ + "img/130.95faa734.jpg";